
var moduleHubSportWrapper = {
    
    orderedSportsArray: null,

    init: function($sportsCarousel){

        var moduleHubSportWrapper = this;

        var i;

        var orderingText, pingying;

        var $sportsArray = $sportsCarousel.find('a');   

       

         $sportsArray.each(function(){   
                originalText = $(this).find('.text').text();  
                if($('html').attr('lang') === 'zh'){
                    $('.hs-bloc-letters').hide();
                    pingying = moduleHubSportWrapper.getPronunciationZh(originalText);
                    orderingText = pingying !== "" ? pingying : 'Pingying not provided';
                } else {
                    orderingText = originalText;
                }
                
                $(this).attr('data-ordering-text', orderingText);
         });

          var aText, bText;

          groupedArrayofSports = {};

          moduleHubSportWrapper.orderedSportsArray = $sportsArray.sort(function(a, b){       
              //on trie dans la liste des sports
            aText = $(a).data('ordering-text');
            bText = $(b).data('ordering-text');
            if(aText < bText) return -1;
            if(aText > bText) return 1;
            return 0;
        });
        
        moduleHubSportWrapper.orderedSportsArray.each(function(){   
            // on recup la premiere lettre - injecte element
            var firstChar = $(this).data('ordering-text').charAt(0).removeDiacritics();
            groupedArrayofSports[firstChar] = groupedArrayofSports[firstChar] || [];
            groupedArrayofSports[firstChar].push($(this));

        });
    

    if($('html').attr('lang') !== 'zh'){
        moduleHubSportWrapper.initCommon($sportsCarousel);
    } else {
        moduleHubSportWrapper.initZh($sportsCarousel);
    }

      
  },
  

    zhDictionary: function(){
        return [
        {
          "zh": "滑雪、滑雪板、无舵雪橇",
          "pingying": "Hua xue, Hua xue ban, Wu tuo xue qiao"
        },
        {
          "zh": "排球和沙滩排球",
          "pingying": "Pai qiu, Sha tan pai qiu"
        },
        {
          "zh": "航海运动",
          "pingying": "Hang hai yun dong"
        },
        {
          "zh": "风筝冲浪板和侧翼",
          "pingying": "Feng zheng chong lang ban, Ce yi"
        },
        {
          "zh": "健步走运动",
          "pingying": "Jian bu zou yun dong"
        },
        {
          "zh": "空手道",
          "pingying": "Kong shou dao"
        },
        {
          "zh": "跆拳道",
          "pingying": "Tai quan dao"
        },
        {
          "zh": "乒乓球运动",
          "pingying": "Ping Pang qiu yun dong"
        },
        {
          "zh": "轮滑",
          "pingying": "Lun hua"
        },
        {
          "zh": "潜水、浮潜",
          "pingying": "Qian shui, Fu qian"
        },
        {
          "zh": "户外山地运动",
          "pingying": "Hu wai shan di yun dong"
        },
        {
          "zh": "舞蹈",
          "pingying": "Wu dao"
        },
        {
          "zh": "篮球运动",
          "pingying": "Lan qiu yun dong"
        },
        {
          "zh": "游泳、水上健身、水球",
          "pingying": "You yong, Shui shang jian shen, Shui qiu"
        },
        {
          "zh": "弓箭",
          "pingying": "Gong jian"
        },
        {
          "zh": "马术运动",
          "pingying": "Ma shu yun dong"
        },
        {
          "zh": "高尔夫",
          "pingying": "Gao er fu"
        },
        {
          "zh": "冲浪、身体冲浪板、滑水",
          "pingying": "Chong lang, Shen ti chong lang ban, Hua shui"
        },
        {
          "zh": "跑步、越野跑、田径",
          "pingying": "Pao bu, Yue ye pao, Tian jin"
        },
        {
          "zh": "网球运动",
          "pingying": "Wang qiu yun dong"
        },
        {
          "zh": "足球",
          "pingying": "Zu qiu"
        },
        {
          "zh": "健身运动",
          "pingying": "Jian shen yun dong"
        },
        {
          "zh": "羽毛球运动",
          "pingying": "Yu mao qiu yun dong"
        },
        {
          "zh": "自行车运动",
          "pingying": "Zi xing che yun dong"
        },
        {
          "zh": "垂钓",
          "pingying": "Chui diao"
        },
        {
          "zh": "攀岩、高山攀登运动",
          "pingying": "Pan yan, Gao shan pan deng yun dong"
        },
        {
          "zh": "瑜伽、普拉提",
          "pingying": "Yujia、Pu la ti"
        },
        {
          "zh": "法式滚球",
          "pingying": "Fa shi gun qiu"
        }
      ];    
    },

    getPronunciationZh: function(name){
        var pingying = '' + $.map(moduleHubSportWrapper.zhDictionary(), function(e,i){
          if( e.zh === name ) {
            return e.pingying;
          }
        });

        return pingying;   
    },  

    initZh: function($sportsCarousel){
        $sportsCarousel.addClass('sbs').slick({
        dots: true,
        arrows:true,
        infinite: false,
        speed: 300,
        rows:2,
        slidesPerRow: 1,
        slidesToScroll: 1,
        useCSS:true,
        useTransform:true,
        variableWidth:false,
        responsive: [
          {
            breakpoint: decathlon.uxBreakpoints.lgMin,
            settings: {
              slidesPerRow: 1
            }
          },
          {
            breakpoint: 961,
            settings: {
              slidesPerRow: 1
            }
          },
          {
            breakpoint: decathlon.uxBreakpoints.smMin,
            settings: {
              arrows: false,
              slidesPerRow: 1
            }
          },
          {
            breakpoint: decathlon.uxBreakpoints.xsMin,
            settings: {
              arrows: false,
              slidesPerRow: 1
            }
          }
        ]
      });
    },

    initCommon: function($sportsCarousel){
          
          var carouselOutput = '<div class="sport-groups-wrapper alpha">';

      for (var k in groupedArrayofSports){
          if (groupedArrayofSports.hasOwnProperty(k)) {
            carouselOutput += '<div class="hs-body-sports">';
            carouselOutput += '<div class="sports-group col-xs-12 col-sm-10 col-md-8">';
            carouselOutput +=   '<div class="sports-wrapper">';
            carouselOutput +=     '<div class="letter"><span><a name="'+k.toUpperCase()+'">' + k + '</a></span></div>';
            carouselOutput +=     '<div class="sports">';

            var sportsLength = groupedArrayofSports[k].length;
            var midpoint = sportsLength%2 === 0 ? sportsLength/2 : (sportsLength/2) + 1;

            var firstLineOfSports = [];
            var secondLineOfSports = [];

            if(sportsLength > 1){
              firstLineOfSports = groupedArrayofSports[k].slice(0, midpoint);
              secondLineOfSports = groupedArrayofSports[k].slice(midpoint, sportsLength);
              if(firstLineOfSports.length > 0){
                carouselOutput +=    '<div class="line">';
                for(i in firstLineOfSports){
                  carouselOutput += firstLineOfSports[i][0].outerHTML;
                }
                carouselOutput +=   '</div>';
              }
              if(secondLineOfSports.length > 0){
                carouselOutput +=   '<div class="line">';
                              for(var j in secondLineOfSports){
                                carouselOutput += secondLineOfSports[j][0].outerHTML;
                              }
                carouselOutput +=   '</div>';
              }

             
            } else {
              carouselOutput +=     '<div class="line">';
              carouselOutput +=       groupedArrayofSports[k][0][0].outerHTML;
              carouselOutput +=     '</div>';
            }
            carouselOutput +=     '</div>';
            carouselOutput +=   '</div>';
            carouselOutput += '</div>';
            carouselOutput += '</div>';
          }
      }

      carouselOutput +=     '</div>';

        $sportsCarousel.empty().append($(carouselOutput));
    }


    
    
}

module.exports = moduleHubSportWrapper;


// WEBPACK FOOTER //
// ./src/modules-es5/pages/hub/hub-sports-wrapper.js